<template>
  <div class="assessment">
    <div class="list" v-show="dataList.length>0">
      <table>
        <tbody>
        <tr>
          <th>序号</th>
          <th>学期</th>
          <th>考试</th>
          <th>评估时间</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{index+1}}</td>
          <td>{{item.gradeName}}</td>
          <td>{{item.nameName}}</td>
          <td>{{item.date}}</td>
          <td :style="{color:item.date?'#Ed7620':'#29A5ED'}">{{item.date?'已评估':'待评估'}}</td>
          <td @click="jump(item)"><span>{{item.date?'查看':'评估'}}</span></td>
        </tr>
        </tbody>
      </table>
      <Pages :page-data="options" :change="list"></Pages>
    </div>
    <div v-show="dataList.length==0">
      <NoContent name="暂无数据!" ></NoContent>
    </div>

  </div>
</template>
<script>
import Pages from '@/components/assembly/Pagination';
import NoContent from "@/components/NoContent";
export default {
  name: "assessment",
  components:{NoContent,Pages},
  data(){
    return {
      dataList:[],
      options:{
        current:1,
        total:0,
        pageSize:10,
        totalPage:1
      },
      name:'',
      bool:false
    }
  },
  methods:{
    list(pageNumber,pageSize){
      const options=this.options;
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.assessmentList, {
        studentId:sessionStorage.getItem("myStudentStudentId"),
        pageNumber:pageNumber||this.options.current,
        pageSize:pageSize||this.options.pageSize,
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let options = this.options;
          options.total= res.data.data.page.count;
          this.dataList = res.data.data.list;
          this.options = options
        }else{

        }
      })
    },
    jump(item){
      if(item.date){
       this.$router.push({path:'/consultant/minestudent/main/implement/assessment/show',query:{...this.$route.query,assessmentId:item.stageAssessId}})
      }else{
        this.$router.push({path:'/consultant/minestudent/main/implement/assessment/add',query:{...this.$route.query,assessmentAddId:item.studentTestScoreId,gradeName:item.gradeName,nameName:item.nameName}})
      }
    }
  },
  mounted() {
    this.list()
  }
}
</script>

<style lang="less" scoped>
  table{
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    tbody{
      width: 100%;
    }
    tr{
      width: 100%;
      line-height: 40px;
      border-radius: 5px;
      border-bottom: 1px solid #ECECEC;
    }
    th{
      font-size: 16px !important;
      background: rgba(61, 144, 246, 0.1);
    }
    td,th{
      text-align: center;
      font-size: 14px;
      span{
        color: #1EA1EE;
        cursor: pointer
      }
    }
  }
  @import "./css/index.less";
</style>